export const SUCCESSFACTORS_HELP_URL =
  "https://help.certn.co/hc/en-us/articles/56301356500371-SAP-SuccessFactors-Certn-integration-setup";

export const SUCCESSFACTORS_SAMPLE_REQUEST = {
  positionApplying: "",
  requestId: "",
  candidateInfo: {
    firstName: "",
    lastName: "",
    phoneNumber: "",
    candidateLanguage: "",
    email: "",
  },
  recruiterEmail: "",
  costCenter: "",
  teamId: "",
  packageId: "",
  applicationId: "",
};

export const SUCCESSFACTORS_SAMPLE_RESPONSE = {
  requestId: "",
  applicationId: "",
  vendorOrderNo: "",
  vendorCode: "",
  status: "",
  errorCode: "",
  errorMessage: "",
};

export function buildSuccessFactorsWebhookUrl(
  domain: string,
  webhookPath: string
) {
  if (!webhookPath) {
    return "";
  }
  if (!domain) {
    return webhookPath;
  }
  return `${domain.replace(/\/$/, "")}${webhookPath}`;
}
